import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import RadioGroup from '@mui/material/RadioGroup';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const options = ['Arrivals', 'Departures', 'Totals'];

const modeOptions = [
    'All Modes',
    'Bus counts by hour',
    'Car counts by hour',
    'All Car Drivers counts by hour',
    'Car Driver (alone) counts by hour',
    'Car Driver (with pass) counts by hour',
    'Car Passenger counts by hour',
    'Coach counts by hour',
    'DLR counts by hour',
    'HGV counts by hour',
    'Motor Cycle counts by hour',
    'Other counts by hour',
    'Park and Ride Bus counts by hour',
    'Pedal Cycle counts by hour',
    'Rail counts by hour',
    'River Boat counts by hour',
    'Taxi counts by hour',
    'Tram counts by hour',
    'Underground counts by hour',
    'Unknown counts by hour',
    'Walk/PT counts by hour',
    'Walk counts by hour',
];

interface IProps {
    open: boolean;
    onClose: () => void;
    landUse: string;
}

export default function ExtractAllOptionsDialog(props: IProps) {
    const { open, onClose, landUse } = props;
    const [direction, setDirection] = useState('Arrivals');
    const [mode, setMode] = useState('All Modes');
    const navigate = useNavigate();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Extract Data Options</DialogTitle>
            <DialogContent>
                <FormControl sx={{ mb: 2 }}>
                    <RadioGroup
                        value={direction}
                        onChange={e => setDirection(e.target.value)}
                    >
                        {options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio size="small" />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                <FormControl>
                    <RadioGroup
                        value={mode}
                        onChange={e => setMode(e.target.value)}
                    >
                        {modeOptions.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio size="small" />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                <DialogActions>
                    <Button
                        onClick={() =>
                            navigate(`/travl/surveyTable?direction=${direction}&landUse=${landUse}&mode=${encodeURIComponent(mode.replace(" counts by hour", ""))}`)
                        }
                    >
                        Ok
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}
